import React, { useEffect, useState, useRef } from 'react';
import { Card, CardHeader, CardBody } from '../../../_metronic/_partials/controls';
import Select from 'react-select';
import { Table } from 'react-bootstrap';
import { getRequest, postRequest, Uri_GetOrganization, Uri_getFacilitiesByOrganizationId, Uri_updateFacilitiesOwnershipGroup } from '../../General/api';
import { successStatusCode, defaultCloseModalTimeout, showSuccessAlertAutoClose } from '../../General/common';

export default function FacilityOwnershipManager() {
  const [facilityOwnershipGroups, setFacilityOwnershipGroups] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [isLoading, setIsLoading] = useState(false);


  const selectedFacilityOwnershipGroup = useRef(null);
  const selectedNewFacilityOwnershipGroup = useRef(null);

  useEffect(() => {
    getRequest(Uri_GetOrganization)
      .then(response => {
        const responseData = response.data;
        if (responseData.statusCode !== successStatusCode || !responseData.result) {
          showSuccessAlertAutoClose('Organization list not found!', 'warning', 'warning!', defaultCloseModalTimeout)
        }

        setFacilityOwnershipGroups(responseData.result.map(facilityGroup => ({ label: facilityGroup.value, value: facilityGroup.key })));

      }).catch(error => {
        console.log(error);
        showSuccessAlertAutoClose('Sorry, an error has occurred', 'warning', 'warning!', defaultCloseModalTimeout);
      });
  }, []);

  const getFacilitiesByOwnershipGroup = (inputValue) => {
    getRequest(`${Uri_getFacilitiesByOrganizationId}?organizationId=${inputValue}`)
      .then(response => {
        const responseData = response.data;
        if (responseData.statusCode !== successStatusCode || !responseData.result) {
          showSuccessAlertAutoClose('Facility list not found!', 'warning', 'warning!', defaultCloseModalTimeout)
        }

        setFacilities(responseData.result.map(facility => ({ ...facility, isChecked: false })));
      }).catch(error => {
        console.log(error);
        showSuccessAlertAutoClose('Sorry, an error has occurred', 'warning', 'warning!', defaultCloseModalTimeout);
      });
  };

  const save = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const selectedFacilities = facilities.filter(facility => facility.isChecked);

    if (selectedFacilities.length === 0) {
      showSuccessAlertAutoClose('Please select at least one facility!', 'warning', 'warning!', defaultCloseModalTimeout);
      setIsLoading(false);
      return;
    }

    const selectedFacilitiesIds = selectedFacilities.map(facility => facility.id);
    const newOwnershipGroupId = selectedNewFacilityOwnershipGroup.current.value;

    postRequest(Uri_updateFacilitiesOwnershipGroup, { "FacilitiesIds": selectedFacilitiesIds, "newOwnershipGroupId": newOwnershipGroupId })
      .then(() => {
        showSuccessAlertAutoClose('Facility ownership group updated successfully!', 'success', 'Success!', defaultCloseModalTimeout);
        getFacilitiesByOwnershipGroup(selectedFacilityOwnershipGroup.current.value);
        setIsLoading(false);
      }).catch(error => {
        console.log(error);
        showSuccessAlertAutoClose('Sorry, an error has occurred', 'warning', 'warning!', defaultCloseModalTimeout);
        setIsLoading(false);
      });
  };

  const handleCheckboxChangeAll = (e) => {
    setFacilities(facilities.map(facility => ({ ...facility, isChecked: e.target.checked })));
  }

  return (
    <>
      <Card>
        <CardHeader title='Facility Ownership Manager'></CardHeader>
        <CardBody>
          <>
            <form onSubmit={e => save(e)}>
              <div className='row'>
                <div className='col-5'>
                  <div className='form-group'>
                    <label className='form-label' htmlFor='facilityOwnershipGroup'>Facility Ownership Group</label>
                    <Select
                      options={facilityOwnershipGroups}
                      id='facilityOwnershipGroup'
                      name='facilityOwnershipGroup'
                      required
                      isSearchable
                      onChange={selectedOption => {
                        selectedFacilityOwnershipGroup.current = selectedOption;
                        getFacilitiesByOwnershipGroup(selectedOption.value);
                      }}
                    />
                  </div>
                </div>
                <div className='col-5'>
                  <div className='form-group'>
                    <label className='form-label' htmlFor='newFacilityOwnershipGroup'>New Facility Ownership Group</label>
                    <Select
                      options={facilityOwnershipGroups}
                      id='newFacilityOwnershipGroup'
                      name='newFacilityOwnershipGroup'
                      required
                      isSearchable
                      onChange={selectedOption => {
                        selectedNewFacilityOwnershipGroup.current = selectedOption;
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='d-flex w-100 justify-content-end py-3'>
                  <button type='submit' className='btn btn-success mr-5 px-10'>{isLoading ? <div className='p-2 spinner spinner-primary'></div> : 'Save'}</button>
                </div>
              </div>
            </form>
            <hr />
            {
              facilities && facilities.length > 0 ? (
                <Table responsive striped hover bordered>
                  <thead>
                    <tr>
                      <th>Facility Name</th>
                      <th className='text-center'>
                        <input
                          type='checkbox'
                          onChange={(e) => { handleCheckboxChangeAll(e) }} />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      facilities.map((facility) => (
                        <tr key={facility.id}>
                          <td>{facility.facilityName}</td>
                          <td className='text-center'>
                            <input
                              type='checkbox'
                              id={facility.id}
                              checked={facility.isChecked}
                              onChange={(e) => {
                                setFacilities(facilities.map(facilityItem => {
                                  if (facilityItem.id === facility.id) {
                                    return { ...facilityItem, isChecked: e.target.checked }
                                  }
                                  return facilityItem;
                                }));
                              }}
                            />
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </Table>
              ) : (
                <div className='text-center'>No data found</div>
              )
            }
          </>
        </CardBody>
      </Card >
    </>
  );
}